import Text, { TEXT_VARIANT, TextTag } from '@pixum/text';
import { logger } from 'utils';
import { DeliveryDateSkeleton } from './DeliveryDateSkeleton';
import type { DeliveryDateAsyncProps } from './types';
import styles from './DeliveryDateStream.module.css';
import clsx from 'clsx';

export async function DeliveryDateAsync(props: DeliveryDateAsyncProps) {
  const { deliveryTimesPromise, stacked, constants } = props;
  const result = await deliveryTimesPromise;

  if (!result.success) {
    logger.error({
      ns: 'cart',
      type: 'DELIVERY_TIMES_FETCH_ERROR',
      severity: 'high',
      msg: result.error.message || 'Failed to fetch delivery times',
    });
    throw new Error(result.error.message || 'Delivery times fetch error');
  }

  const deliveryTimes = result.data;

  if (!deliveryTimes) {
    logger.warn({ ns: 'cart', msg: 'DeliveryDateAsync: Delivery times data is null or undefined' });

    return <DeliveryDateSkeleton />;
  }

  if (!deliveryTimes.showDeliveryInfo) {
    return null;
  }

  const { estimatedMinDeliveryDate, estimatedMaxDeliveryDate } = deliveryTimes;

  const isRange = estimatedMinDeliveryDate !== estimatedMaxDeliveryDate;
  const dateRange = isRange ? (
    <>
      {estimatedMinDeliveryDate}
      <span className={styles.srOnly}>{constants['i18n_until']}</span>
      <span aria-hidden="true">{' – '}</span>
      {estimatedMaxDeliveryDate}
    </>
  ) : estimatedMinDeliveryDate;

  return (
    <Text className={clsx(styles.date, stacked && styles.stacked)} tag={TextTag.DIV}>
      <Text variant={TEXT_VARIANT.SUBHEADLINE}>{constants['i18n_expected-delivery-date']} </Text>
      <Text className={styles.dateRange} variant={TEXT_VARIANT.CAPTION}>
        {dateRange}
      </Text>
    </Text>
  );
}
